const mutations = {
  SET_CLEAR_BRANDUNIT({ data }) {
    data.unitsList = [];
  },

  SET_UNITS_LIST({ data }, units) {
    data.unitsList = units;
  },

  SET_UNIT({ data }, unit) {
    data.selectedUnit = unit;
  },

  SET_UNIT_CONFIGS({ data }, unit) {
    data.unitConfigs = unit;
  },

  SET_CURRENT_BRAND_NAME_ID({ data }, { brandName, brandId }) {
    const name = brandName || data.currentBrand.brandName;

    data.currentBrand = {
      brandName: name,
      brandId
    };
  },

  SET_CURRENT_UNIT_NAME_ID({ data }, { unitName, unitId }) {
    data.currentUnit = {
      unitName,
      unitId
    };
  },

  SET_CLEAR_CURRENT_BRAND({ data }) {
    data.currentBrand = { brandId: null, brandName: null };
    localStorage.removeItem('brandId');
  },

  SET_CLEAR_CURRENT_UNIT({ data }) {
    data.currentUnit = { unitId: null, unitName: null };
    localStorage.removeItem('unitId');
  }
};

export default mutations;
